import React, { createContext, useContext, useState, useEffect } from 'react';

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ms_wishlist') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('ms_wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  const toggle = (material, owner) => {
    setWishlist(prev => {
      const exists = prev.find(i => i._id === material._id);
      if (exists) return prev.filter(i => i._id !== material._id);
      return [...prev, { ...material, shopName: owner?.shopName, ownerId: owner?._id }];
    });
  };

  const isWishlisted = (id) => wishlist.some(i => i._id === id);

  return (
    <WishlistContext.Provider value={{ wishlist, toggle, isWishlisted, count: wishlist.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
